'use strict';
angular.module("iwoNoticeDetailModule", []).
controller("iwoNoticeDetailCtrl", ["trsHttpService", "$state", "$scope", "$q", "modalDialog", function(trsHttpService, $state, $scope, $q, modalDialog) {
    initStatus();
    initData();
    /**
     * [initStatus description] 状态初始化
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            noticeId: JSON.parse($state.params.noticeid)
        };
        $scope.data = {};
        $scope.headPic = '';
    }
    /**
     * [initData description] 数据初始化
     * @return {[type]} [description]
     */
    function initData() {
        getNoticeDetail();
    }
    function getNoticeDetail() {
        let defer = $q.defer();
        let params = {
            serviceid: 'notice',
            method: 'noticeDetial',
            noticeid: $scope.status.noticeId
        }
        trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "GET").then((data) => {
            if (data.issuccess == 'false') {
                modalDialog.alertType('', data.msg, 'error', false);
            } else {
                $scope.data.noticeInfo = {
                    typename: data.data.typename,
                    typeid: data.data.typeid,
                    title: data.data.title,
                    titlecolor: data.data.titlecolor,
                    content: data.data.content,
                    appendixinfo: data.data.appendixs.map((_item) => {
                        return {
                            FileSize: _item.filesize,
                            FileDesc: _item.filedesc,
                            FileName: _item.filename,
                        }
                    }),
                }
                defer.resolve();
            }
        });
        return defer.promise;
    }
    /**
     * [downloadFile description] 文件下载
     * @param  {[type]} file [description] 文件
     * @return {[type]}      [description]
     */
    $scope.downloadFile = function(file) {
        window.open("/message/notice/downFile?filename=" + file.FileName);
    }
}]);